import _styled from '@emotion/styled/base';
import { tooltip } from '@tablecheck/tablekit-core';
var Tooltip = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e11uvj250"
} : {
  target: "e11uvj250",
  label: "Tooltip"
})(tooltip.baseStyles, ";");
export { Tooltip };
